<template></template>

<script>
	import https, { fetchGet, fetchPost } from '../../../https.js'
    export default {
        created() {
			fetchGet('/login/getPortal', {}).then(res => {
				let isPortal = res.data.code=='200' && res.data.enable == '1';
				let param = this.getRequestParam();
				var token = param['token'];
				//门户登录
				if (isPortal && token || (localStorage.getItem("token") && localStorage.getItem('portalLogin') == 'true')) {
					this.portalLogin((token ? token : localStorage.getItem("token")),res.data.url);
				} else{
					localStorage.clear();
					window.location.href = res.data.url+"?token="+token;
				}
			});
        },
        methods: {
			portalLogin(token,url){
				fetchPost('/login/portalLogin', token).then(res => {
					if(res.data.success) {
						let currUserObj = res.data.obj.user;
						localStorage.setItem('portalLogin', 'true');
						localStorage.setItem('token', token);
						localStorage.setItem('user', JSON.stringify(res.data.obj.user));
						//  获取当前用户权限菜单
						this.getCurrUserRoleMenuFunctionList().then(res => {
							if(currUserObj && currUserObj.userType == '0') {    //  超管默认指向集团管理页面
								this.$router.push('/groupCompany');
							} else {
								let routearr = localStorage.getItem("routearr");
								if(routearr && routearr.indexOf('homeInfo') == -1) {
									let pathList = routearr.split(',');
									pathList = pathList.filter(path => {
										return this.menuTitleList.indexOf(path) == -1;
									});
									this.$router.push('/' + pathList[0]);
								} else {
									this.$router.push('/homeInfo');  //  默认指向首页
								}
							}
						});
					} else {
						localStorage.clear();
						window.location.href = url+"?token="+token;
						this.$message.error('登录失败：' + res.data.message);
					}
				}).catch(error => {
					localStorage.clear();
					window.location.href = url+"?token="+token;
					this.$message.error('登录失败：' + error);
				});
			},
			async getCurrUserRoleMenuFunctionList() {
			    await fetchPost('/sys/main/getCurrUserMenuFunctionList', localStorage.getItem('token')).then(res => {
			        if(res.data.success) {
			            let userFunction = res.data.obj.userFunction;
			            if(userFunction && userFunction.length > 0) {
			                userFunction.forEach(menuObj => {
			                    if(menuObj.children && menuObj.children.length > 0) {
			                        menuObj.children.unshift({"label": menuObj.label});
			                    }
			                });
			            }
			            let currUser = JSON.parse(localStorage.getItem('user'));
			            let routearr = res.data.obj.routearr;
			            if(currUser && currUser.userType != this.userTypeCon.USER_TYPE_SUPER) {
			                if(!routearr) {
			                    this.$message.error("登录失败：当前登录用户未配置菜单权限！");
			                    return;
			                } else {
			                    localStorage.setItem('currUserMenuFunction', JSON.stringify(userFunction));
			                    localStorage.setItem('routearr', routearr);
			                }
			            } else {
			                localStorage.setItem('currUserMenuFunction', JSON.stringify(userFunction));
			                localStorage.setItem('routearr', routearr);
			            }
			        } else {
			            this.$message.error('加载页面菜单失败：' + error);    
			        }
			    }).catch(error => {
			        this.$message.error('加载页面菜单失败：' + error);
			    });
			},
			getRequestParam() {   //  获取请求后面的参数
				var requestParam = new Object();
				if(location.href.indexOf('?') != -1) {
					var url = location.href.substring(location.href.indexOf('?')); //获取url中"?"符后的字串
					var str = url.substr(1);
					let strs = str.split("&");
					for (var i = 0; i < strs.length; i++) {
						requestParam[strs[i].split("=")[0]] = decodeURI(strs[i].split("=")[1]); //获取中文参数转码<span style="font-family: Arial, Helvetica, sans-serif;">decodeURI</span>，（unescape只针对数字，中文乱码)
					}
					}
				return requestParam;
			}
        }
    }
</script>